/* Rhino Rdy navigation: systems panel (hover/click on desktop), mobile drawer, Esc to close. No polling. */
(function () {
  'use strict';
  const header = document.querySelector('[data-rr-header]'); if (!header) return;
  const panel = header.querySelector('[data-rr-panel]');
  const trigger = header.querySelector('[data-rr-panel-trigger]');
  const drawer = header.querySelector('[data-rr-drawer]');
  /* The drawer must not live inside the header: the floating header's backdrop-filter (and any transform) makes it the
     containing block for fixed descendants, collapsing the drawer to the header's height. Re-parent it to body. */
  if (drawer) document.body.appendChild(drawer);
  const burger = header.querySelector('[data-rr-burger]');
  let hoverTimer = null, pinned = false; /* pinned = opened by a click; stays until a click elsewhere, Esc, or the trigger again */

  function setPanel(open, byClick) {
    if (open) requestAnimationFrame(shapeCards);
    if (!panel || !trigger) return;
    panel.classList.toggle('open', open);
    panel.classList.toggle('pinned', !!(open && byClick));
    trigger.setAttribute('aria-expanded', String(open));
    pinned = !!(open && byClick);
  }
  if (panel) panel.addEventListener('transitionend', e => { if (e.target === panel) shapeCards(); }); /* the panel slides 6px on open; snap the rings again once it has settled */
  if (trigger && panel) {
    trigger.addEventListener('click', () => {
      const isOpen = panel.classList.contains('open');
      if (isOpen && pinned) setPanel(false); else setPanel(true, true);
    });
    header.addEventListener('mouseenter', () => clearTimeout(hoverTimer), true);
    [trigger, panel].forEach(el => {
      el.addEventListener('mouseenter', () => { clearTimeout(hoverTimer); if (!pinned && matchMedia('(hover: hover)').matches) setPanel(true); });
      el.addEventListener('mouseleave', () => { if (pinned) return; hoverTimer = setTimeout(() => setPanel(false), 180); });
    });
    document.addEventListener('click', e => { if (!header.contains(e.target)) setPanel(false); });
  }
  function setDrawer(open) {
    if (open) requestAnimationFrame(shapeCards);
    if (!drawer || !burger) return;
    drawer.classList.toggle('open', open);
    burger.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('rr-nav-lock', open);
  }
  if (burger && drawer) burger.addEventListener('click', () => { setDrawer(!drawer.classList.contains('open')); requestAnimationFrame(shapeCards); });
  /* Drawer plates share the button geometry: 5px corners, 45° chamfer top-right with softened ends (see ctaPath in core-pdp.js) */
  function platePath(W, H) {
    const r = 5, c = Math.min(28, Math.round(H * 0.42)), k = 4, d = k / Math.SQRT2; /* one 28px cut on every plate, like the button; capped on short line rows so the corner stays a corner */
    return `M${r} 0H${W - c - k}Q${W - c} 0 ${W - c + d} ${d}L${W - d} ${c - d}Q${W} ${c} ${W} ${c + k}V${H - r}Q${W} ${H} ${W - r} ${H}H${r}Q0 ${H} 0 ${H - r}V${r}Q0 0 ${r} 0Z`;
  }
  function shapeCards() {
    document.querySelectorAll('[data-card]').forEach(el => {
      /* fractional size, not offsetWidth: grid columns land on sub-pixels, and a rounded box lags the card by up to a pixel (a gap on one edge) */
      const box = el.getBoundingClientRect(), W = Math.round(box.width * 100) / 100, H = Math.round(box.height * 100) / 100; if (!W || !H) return;
      el.style.clipPath = `path("${platePath(W, H)}")`;
      /* outlined plates: a stroke along the same geometry (a box-shadow ring would stop at the chamfer) */
      /* Outlined plates. The outline is two fills, not a stroke: the plate itself is filled with the line colour and a copy of
         the same shape, 1px smaller on every side, is filled with the ground. All four edges are then exactly as thick as each
         other wherever the plate sits. (The earlier 1px stroke had to be nudged onto the device-pixel grid, and it was measured
         while the phone menu was still sliding in, so the right and bottom edges came out thinner than the top and left.)
         Dashed "soon" plates keep the stroke: a dash pattern needs one. */
      if (el.classList.contains('hollow') || el.classList.contains('line') || el.classList.contains('extra')) {
        const dashed = el.classList.contains('soon');
        let svg = el.querySelector(':scope > svg.ring');
        if (!dashed) {
          if (svg) svg.remove();
          el.classList.add('ringfill');
          el.style.setProperty('--plate-inner', `path("${platePath(Math.max(0, W - 2), Math.max(0, H - 2))}")`);
        } else {
          if (!svg) { svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); svg.setAttribute('class', 'ring'); svg.setAttribute('aria-hidden', 'true'); svg.innerHTML = '<path/>'; el.appendChild(svg); }
          svg.setAttribute('viewBox', `0 0 ${W} ${H}`); svg.setAttribute('preserveAspectRatio', 'none'); svg.style.width = W + 'px'; svg.style.height = H + 'px';
          svg.querySelector('path').setAttribute('d', platePath(W - 1, H - 1));
          svg.querySelector('path').setAttribute('transform', 'translate(0.5 0.5)');
        }
      }
    });
  }
  if ('ResizeObserver' in window) { const ro = new ResizeObserver(shapeCards); document.querySelectorAll('[data-card]').forEach(el => ro.observe(el)); }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(shapeCards);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { setPanel(false); setDrawer(false); } });
  addEventListener('resize', () => { if (innerWidth > 900) setDrawer(false); });

  /* Scroll behaviour: hide on the way down, float back in (frosted) on the way up, solid at the top. */
  let lastY = scrollY;
  const onScroll = () => {
    const y = Math.max(0, scrollY), dy = y - lastY, open = (drawer && drawer.classList.contains('open')) || (panel && panel.classList.contains('open'));
    if (y < 8) { header.classList.remove('is-hidden', 'is-floating'); }
    else if (open) { header.classList.remove('is-hidden'); }
    else if (dy > 4 && y > header.offsetHeight) { header.classList.add('is-hidden'); }
    else if (dy < -4) { header.classList.remove('is-hidden'); header.classList.add('is-floating'); }
    lastY = y;
  };
  addEventListener('scroll', onScroll, { passive: true });

  /* Logo animation. Plays once per visit on first load, then replays on hover (pointer devices) with a
     cooldown. Never on a timer: a mark that keeps moving becomes noise. Off under prefers-reduced-motion.
     lottie_light (SVG only) loads lazily and only here. */
  const logo = header.querySelector('[data-rr-logo]');
  const anim = logo && logo.querySelector('[data-logo-anim]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (logo && anim && !reduced) {
    let lib = null, loading = null, playing = false, last = 0;
    const load = () => loading || (loading = new Promise(res => {
      const s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie_light.min.js'; s.async = true;
      s.onload = () => { lib = window.lottie || window.bodymovin; res(lib); }; s.onerror = () => res(null);
      document.head.appendChild(s);
    }));
    const play = async () => {
      if (playing || Date.now() - last < 4000) return;
      const L = lib || await load(); if (!L) return;
      playing = true; last = Date.now();
      anim.innerHTML = '';
      const a = L.loadAnimation({ container: anim, renderer: 'svg', loop: false, autoplay: true, path: logo.dataset.lottie });
      let done = false;
      const finish = () => { if (done) return; done = true; playing = false; logo.classList.remove('animating'); anim.hidden = true; try { a.destroy(); } catch (e) {} };
      a.addEventListener('DOMLoaded', () => { anim.hidden = false; logo.classList.add('animating'); });
      a.addEventListener('complete', finish);
      setTimeout(finish, 8000);
    };
    let played = false; try { played = sessionStorage.getItem('rr-logo-played') === '1'; } catch (e) {}
    if (!played) { play(); try { sessionStorage.setItem('rr-logo-played', '1'); } catch (e) {} }
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) logo.addEventListener('mouseenter', play);
  }

  /* Cart pulse. When an item lands in the cart, the count pill emits three soft radar rings and stops.
     A page that loads with items already in the cart gets one ring after a beat. Never continuous. */
  const cartLink = header.querySelector('#cart-icon-bubble');
  if (cartLink && !reduced) {
    const pulse = n => { const pill = cartLink.querySelector('.cart-count-bubble'); if (!pill) return; pill.style.setProperty('--rings', n); pill.classList.remove('pulse'); void pill.offsetWidth; pill.classList.add('pulse'); };
    let count = () => { const p = cartLink.querySelector('.cart-count-bubble span[aria-hidden]'); return p ? parseInt(p.textContent, 10) || 0 : 0; };
    let lastCount = count();
    if (lastCount > 0) setTimeout(() => pulse(1), 1200);
    new MutationObserver(() => { const c = count(); if (c > lastCount) pulse(3); lastCount = c; }).observe(cartLink, { childList: true, subtree: true, characterData: true });
  }
})();
/* Shopify's video_tag renders a fallback <img> without alt inside every <video>; mark it decorative. */
document.querySelectorAll('video > img:not([alt])').forEach(i => i.setAttribute('alt', ''));

/* Desktop header search: word ↔ field in place */
(function () {
  const f = document.querySelector('[data-hsearch]'); if (!f) return;
  const open = f.querySelector('[data-hsearch-open]'), field = f.querySelector('#hs-field'), input = f.querySelector('[data-hsearch-input]'), close = f.querySelector('[data-hsearch-close]');
  const set = (on) => { f.classList.toggle('is-open', on); field.hidden = !on; open.setAttribute('aria-expanded', String(on)); if (on) { input.focus(); input.select(); } else { open.focus(); } };
  open.addEventListener('click', () => set(true));
  close.addEventListener('click', () => set(false));
  input.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); set(false); } });
  document.addEventListener('click', e => { if (f.classList.contains('is-open') && !f.contains(e.target)) set(false); });
  f.addEventListener('submit', e => { if (!input.value.trim()) { e.preventDefault(); input.focus(); } });
})();
